import apiClient from './apiClient';

// ==================== Beta Analytics API ====================

export const betaAPI = {
  // Track a single feature usage event
  track: async (feature, action, metadata = null) => {
    try {
      await apiClient.post('/beta/track', { feature, action, metadata });
    } catch (error) {
      // Silently fail - don't interrupt user experience for analytics
      console.debug('Analytics track failed:', error);
    }
  },

  // Track multiple events at once
  trackBatch: async (events) => {
    try {
      await apiClient.post('/beta/track-batch', events);
    } catch (error) {
      console.debug('Analytics batch track failed:', error);
    }
  },

  // Get analytics summary (admin only)
  getSummary: async (days = 30) => {
    const response = await apiClient.get(`/beta/analytics/summary?days=${days}`);
    return response.data;
  },

  // Get feature-specific analytics (admin only)
  getFeatureAnalytics: async (feature, days = 30) => {
    const response = await apiClient.get(`/beta/analytics/feature/${feature}?days=${days}`);
    return response.data;
  },

  // Get dashboard overview (admin only)
  getDashboardOverview: async () => {
    const response = await apiClient.get('/beta/dashboard/overview');
    return response.data;
  },

  // Get activity chart data (admin only)
  getActivityData: async (days = 30) => {
    const response = await apiClient.get(`/beta/dashboard/activity?days=${days}`);
    return response.data;
  },

  // Submit feedback
  submitFeedback: async (type, title, description, page = null, severity = 'medium') => {
    const response = await apiClient.post('/beta/feedback', {
      type,
      title,
      description,
      page,
      severity
    });
    return response.data;
  },

  // Get feedback list
  getFeedback: async (status = null, type = null, limit = 50) => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (type) params.append('type', type);
    params.append('limit', limit);
    const response = await apiClient.get(`/beta/feedback?${params.toString()}`);
    return response.data;
  },

  // Get feedback stats (admin only)
  getFeedbackStats: async () => {
    const response = await apiClient.get('/beta/feedback/stats');
    return response.data;
  },

  // Update feedback status (admin only)
  updateFeedback: async (feedbackId, status = null, adminNotes = null) => {
    const response = await apiClient.put(`/beta/feedback/${feedbackId}`, {
      status,
      adminNotes
    });
    return response.data;
  },

  // Delete feedback (admin only)
  deleteFeedback: async (feedbackId) => {
    const response = await apiClient.delete(`/beta/feedback/${feedbackId}`);
    return response.data;
  }
};
